import React from 'react';
import { Badge } from 'antd';

export default function KoBadge({color, offset, dot,size, count, children, showZero, ribbon, text }) {
  return (
    !ribbon ? <Badge color={color ?  color : `var(--palette-primary-darker)`} dot={dot} showZero={showZero} size={size} offset={offset} count={count}>
      {children}
    </Badge> : <Badge.Ribbon text={text} color={color ?  color : `var(--palette-primary-darker)`} >
      {children}
    </Badge.Ribbon>
  );
}
